import { reactStore } from "../store";
import { showLegacyDialog, hideLegacyDialog } from "../store/actions";

// helper: build colon/semicolon strings from selectedItems if not provided
function withIdStrings(ctx) {
  const items = Array.isArray(ctx) ? ctx : [ctx];
  const ids = items.map(x => (x && x.ID) ? x.ID : x).filter(Boolean);
  return {
    ...ctx,
    selectedItemsColon: ids.join(":"),
    selectedItemsSemiColon: ids.join(";"),
  };
}

// subscribe-once helper to resolve a promise when this dialog closes
function waitForClose(dialogId) {
  return new Promise((resolve) => {
    const unsubscribe = reactStore.subscribe(() => {
      const s = reactStore.getState();
      // your reducer clears dialogType/props on close; we also stash the id in dialogProps
      const currentId = s.legacyDialog?.dialogProps?.id;
      const isOpen = !!s.legacyDialog?.dialogType || !!currentId;
      if (!isOpen || currentId !== dialogId) {
        // dialog either closed or replaced; resolve
        unsubscribe();
        resolve();
      }
    });
  });
}

// core open function: dispatch and return {id, whenClosed, close()}
function openResolved({ dialogType = null, dialogProps = {}, dialogContentProps = {} }) {
  const id = dialogProps.id || 123; //nanoid();
  const propsWithId = { ...dialogProps, id };

  reactStore.dispatch(showLegacyDialog(dialogType, propsWithId, dialogContentProps));

  return {
    id,
    whenClosed: waitForClose(id),
    close: () => reactStore.dispatch(hideLegacyDialog()),
  };
}

export function openVersionHistory(ctx) {
  const c = withIdStrings(ctx);
  return openResolved({
    dialogType: "VERSION_HISTORY",
    dialogProps: {
      title: "Version History",
      width: 960,
      height: 250,
      url: `legacy/versionhist.aspx?FileID=${encodeURIComponent(c.selectedItemsColon)}`
    }
  });
}

export function openNotes(ctx) {
  const c = withIdStrings(ctx);
  return openResolved({
    dialogType: "NOTES",
    dialogProps: {
      title: "document notes",
      width: 530,
      height: 460,
      url: `legacy/docnotes.aspx?FileID=${encodeURIComponent(c.selectedItemsColon)}`
    }
  });
}

export function openWorkflowStep(ctx) {
  const c = withIdStrings(ctx);
  return openResolved({
    dialogType: "WORKFLOW_STEP",
    dialogProps: {
      title: "Workflow Task",
      width: 565,
      height: 610,
      blankSrc: "/legacy/blank.aspx",
      url: `legacy/processselect.aspx?FileID=${encodeURIComponent(c.selectedItemsColon)}`
    }
  });
}

export function openWorkflow(ctx) {
  const c = withIdStrings(ctx);
  return openResolved({
    dialogType: "WORKFLOW",
    dialogProps: {
      title: "Workflow Request",
      width: 445,
      height: 475,
      blankSrc: "/legacy/blank.aspx",
      post: {
        action: "legacy/workflowrequest.aspx",
        fields: {
          AddFile: c.selectedItemsSemiColon,
          nodeid: c.nodeid || "",
          FileId: c.fileId || ""
        }
      }
    }
  });
}

export function openMessage(ctx) {
  const c = withIdStrings(ctx);
  return openResolved({
    dialogType: "MESSAGE",
    dialogProps: {
      title: "New Message",
      width: 445,
      height: 625,
      blankSrc: "/legacy/blank.aspx",
      post: {
        action: "legacy/messagenew.aspx",
        fields: {
          AddFile: c.selectedItemsSemiColon,
          nodeid: c.nodeid || "",
          FileId: c.fileId || ""
        }
      }
    }
  });
}

// open a GET dialog with explicit props
export function openUrl({ title, url, width = 800, height = 600, frameName = "LegacyDialog", blankSrc = "about:blank" }) {
  return openResolved({
    dialogProps: { title, url, width, height, frameName, blankSrc }
  });
}

// open a POST dialog with explicit props
export function post({ title, action, fields, width = 800, height = 600, frameName = "LegacyDialog", blankSrc = "/legacy/blank.aspx" }) {
  return openResolved({
    dialogProps: { title, width, height, frameName, blankSrc, post: { action, fields } }
  });
}
